import { ApisOverview } from '../components/apis-overview';

const ApisTab = () => <ApisOverview />;

export default ApisTab;
